// client/src/modules/support/nav.ts
import type { NavItem } from '../types';
import { SUPPORT_PAGE } from '../pageAccess';

/**
 * Navigation items for Support module sidebar.
 * Flat structure: Dashboard, Inbox (unified), On-Call, Logins, Email Signature, Settings.
 * Web Forms removed — submissions now surface in the unified Inbox.
 */
export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/support/dashboard', requirePage: SUPPORT_PAGE },
  { label: 'Inbox', path: '/support/inbox', requirePage: SUPPORT_PAGE },
  { label: 'On-Call', path: '/support/on-call' },
  { label: 'Logins', path: '/support/logins', requirePage: SUPPORT_PAGE },
  { label: 'Email Signature', path: '/support/signature' },
  { label: 'Settings', path: '/support/settings', requirePage: SUPPORT_PAGE },
];
